'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _society = require('@prisma-cms/society');

var _Object = require('@prisma-cms/society/lib/components/pages/ChatRooms/View/Object');

var _Object2 = _interopRequireDefault(_Object);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _materialUi = require('material-ui');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatRoomsByTaskView = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(ChatRoomsByTaskView, _PrismaCmsComponent);

  function ChatRoomsByTaskView() {
    _classCallCheck(this, ChatRoomsByTaskView);

    return _possibleConstructorReturn(this, _PrismaCmsComponent.apply(this, arguments));
  }

  ChatRoomsByTaskView.prototype.createChatRoom = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(data) {
      var _this2 = this;

      var inRequest, createChatRoomProcessor;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inRequest = this.state.inRequest;

              if (!inRequest) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              this.setState({
                inRequest: true
              });
              createChatRoomProcessor = this.context.query.createChatRoomProcessor;
              _context.next = 7;
              return this.mutate({
                mutation: (0, _graphqlTag2.default)(createChatRoomProcessor),
                variables: {
                  data: data
                }
              }).catch(function (error) {
                console.error(error);
                /**
                 * Восстанавливаем право запроса только в случае ошибки, так как создаться комната должна только одна.
                 * А так, пока данные обновляются и подтягивается информация о чат-комнате, юзер может еще раз нажать.
                 */

                _this2.setState({
                  inRequest: false
                });
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function createChatRoom(_x) {
      return _ref.apply(this, arguments);
    }

    return createChatRoom;
  }();

  ChatRoomsByTaskView.prototype.render = function render() {
    var _this3 = this;

    var currentUser = this.context.user;

    var _ref2 = currentUser || {},
        currentUserId = _ref2.id;

    var _props = this.props,
        _props$data = _props.data,
        loading = _props$data.loading,
        objectsConnection = _props$data.objectsConnection,
        task = _props.task,
        updateChatRoomProcessor = _props.updateChatRoomProcessor;
    var inRequest = this.state.inRequest;
    var taskId = task.id,
        name = task.name,
        Project = task.Project;

    if (!taskId) {
      return null;
    }

    var _ref3 = Project || {},
        projectCreatedBy = _ref3.CreatedBy;

    var _ref4 = projectCreatedBy || {},
        projectCreatedById = _ref4.id;

    var chatRoom = objectsConnection && objectsConnection.edges[0] && objectsConnection.edges[0].node || null; // console.log("task", task);

    var output = null;

    if (chatRoom) {
      output = _react2.default.createElement(_Object2.default, {
        data: {
          object: chatRoom
        },
        mutate: updateChatRoomProcessor
      });
    } else {
      if (!loading) {
        output = _react2.default.createElement(_materialUi.Button, {
          color: 'primary',
          disabled: inRequest ? true : false,
          onClick: function onClick(event) {
            if (!currentUserId) {
              var openLoginForm = _this3.context.openLoginForm;
              openLoginForm();
              return;
            }

            var Members = {
              connect: []
            };

            if (projectCreatedById && projectCreatedById !== currentUserId) {
              Members.connect.push({
                id: projectCreatedById
              });
            }

            _this3.createChatRoom({
              name: name,
              isPublic: true,
              Task: {
                connect: {
                  id: taskId
                }
              },
              Members: Members
            });
          }
        }, "\u041D\u0430\u0447\u0430\u0442\u044C \u0447\u0430\u0442");
      }
    }

    return _PrismaCmsComponent.prototype.render.call(this, output);
  };

  return ChatRoomsByTaskView;
}(_component2.default), _class.propTypes = {
  data: _propTypes2.default.object.isRequired,
  task: _propTypes2.default.object.isRequired,
  updateChatRoomProcessor: _propTypes2.default.func.isRequired
}, _temp);
var ChatRoomsByTask = (_temp2 = _class2 = function (_ChatRooms) {
  _inherits(ChatRoomsByTask, _ChatRooms);

  function ChatRoomsByTask() {
    _classCallCheck(this, ChatRoomsByTask);

    return _possibleConstructorReturn(this, _ChatRooms.apply(this, arguments));
  }

  ChatRoomsByTask.prototype.setPageMeta = function setPageMeta(meta) {};

  ChatRoomsByTask.prototype.getFilters = function getFilters() {
    return;
  };

  return ChatRoomsByTask;
}(_society.ChatRooms), _class2.defaultProps = _extends({}, _society.ChatRooms.defaultProps, {
  View: ChatRoomsByTaskView
}), _temp2);
exports.default = ChatRoomsByTask;
module.exports = exports['default'];